//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectBodyList.js";
import "../no/SelectNXObjectList.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AssociationSetting",1,0],[0,"CreateNewGroup",1,0],[0,"CreateScrewThroughHole",1,0],[0,"CreateSolidSetting",1,0],[1,"DistanceFactor",0,"Expression",0],[0,"EntireComponentPattern",1,0],[0,"GroupSetName",1,0],[0,"ModeSelection",1,0],[0,"PreviewFalseBody",1,0],[0,"ReferenceSets",1,0],[0,"RemoveToolComponent",1,0],[0,"SaveSetting",1,0],[1,"SelectTarget",0,"SelectBodyList",0],[1,"SelectTool",0,"SelectNXObjectList",0],[0,"SelectTypes",1,0],[0,"ShowSetting",1,0],[0,"ToolReferenceSet",1,0]],[[[],"FindIntersection",{},0,0],[[],"CheckStatus",{},0,0],[[],"RemovePocket",{},0,0],[[],"EditFalseBody",{},0,0],[[],"DeleteFamilyToolFalse",{},0,0],[[],"InitializeFamilyData",{},0,0]],[]];
SPLM.Tooling.PocketBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.PocketBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.PocketBuilder.ModeType = Object.freeze({
    "Subtract" : "Subtract", "Add" : "Add"});

SPLM.Tooling.PocketBuilder.ToolType = Object.freeze({
    "Part" : "Part", "Solid" : "Solid"});

SPLM.Tooling.PocketBuilder.RsetType = Object.freeze({
    "False" : "False", "True" : "True", "Both" : "Both", "AddMaterial" : "AddMaterial", "NoChange" : "NoChange"});

export default SPLM;